import { Box, Form, Heading, LabeledControl, Paragraph } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

export const WizardForm = styled(Form, {
  base: {
    flexGrow: 2,
  },
});

export const WizardHeading = styled(Heading, {
  base: {
    display: 'block',
    marginBottom: '400',
  },
});

export const WizardBody = styled(Paragraph, {
  base: {
    display: 'block',
    marginBottom: '600',
  },
});

export const WizardFormSectionContainer = styled(Box, {
  base: {
    flexGrow: '1',
    marginBottom: '800',

    '&:last-child': {
      marginBottom: '600',
    },
  },
});

export const WizardFlexContainer = styled(Box, {
  base: {
    display: 'flex',
    flexDirection: { base: 'column', xxl: 'row' },
    justifyContent: 'space-between',
  },
});

export const WizardLabeledControl = styled(LabeledControl, {
  base: {
    minWidth: '50%',
  },
});

export const ReviewSectionTitle = styled(Box, {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '100',

    '& > *:not(:last-child)': {
      marginRight: '200 !important',
    },
  },
});
